import { BCMSRecord, BrandingStyle, DisabledPrompt, useGlobalController } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, LayoutContainer, LeftColumnContainer, RightColumnContainer } from "components/shared";
import { Message, MessageCategory } from "model";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function MobileMessagesTable
 * @return {React.Component}
 * @exported true
 * @description This component is used as a mobile table in the MessagesPage.
 */
export default function MobileMessagesTable(props) {
    const controller = useGlobalController();
    BCMSRecord.globalControllerFor([ Message, MessageCategory ], controller);

    const messages = Message.initAll().map(message => <MobileMessagesTableRow key={ `Message_${ message.id }` } item={ message } />, []);

    return (
        <div className="mobile-messages-table flex-container flex-vertical flex-width">
            { messages }
        </div>
    )
}

/**
 * @function MobileMessagesTableRow
 * @param {STRING} message - Sets the message text.
 * @param {STRING} trackingId - SSets the tracking Id. 
 * @param {STRING} dateTime - Sets the date and time. 
 * @param {STRING} lastUpdated - Sets date and time of last update. 
 * @param {STRING} category - Sets the catergory name.
 * @return {React.Component}
 * @exported false
 * @description This component is used as a mobile table row in the MessagesPage. 
 */
function MobileMessagesTableRow(props) {
    const message = props.item ?? Message.firstInstanceOf();
    const updatedDate = `${ message.updatedDate.format("m/d/Y") } ${ message.updatedTime }`;

    return (
        <div className="mobile-messages-table-row flex-container flex-horizontal">
            <LayoutContainer>
                <LeftColumnContainer>
                    <DisabledPrompt>
                        <BrandingStyle className="clickable link" style={{ "color": "links_abi22" }} element={
                        <p className="message-label clickable">{ message.message  }</p>
                        }
                    />
                    </DisabledPrompt>
                    <p className="tracking-id-label"><b>Tracking ID</b></p>
                    <p className="last-updated-label"><b >Last Updated</b></p>
                    <p className="category-label"><b>Category</b></p>
                </LeftColumnContainer>
                <CenterContentContainer>
                    <p className="text-right tracking-id-text">{ message.trackingID }</p>
                    <p className="text-right last-updated-text">{ updatedDate }</p>
                    <p className="text-right category-text">{ message.category.description }</p>
                </CenterContentContainer>
                <RightColumnContainer>
                    <DisabledPrompt><SVGAsset id="TrashcanXIcon" className="trash-can-x-icon clickable" /></DisabledPrompt>
                </RightColumnContainer>
            </LayoutContainer>
        </div>
    )

}